// @flow

import * as React from 'react';

import {useLocation} from 'docs/data';

export const useExpandableState = (
  initiallyOpen: boolean,
  hash: ?string,
): [boolean, (boolean | ((boolean) => boolean)) => void] => {
  const [expanded, setExpanded] = React.useState<boolean>(initiallyOpen);
  const {location} = useLocation();

  // If section is not expanded and location.hash matches href then expand section
  React.useEffect(() => {
    if (hash && location.hash === hash) {
      setExpanded(true);
    }
  }, [location.hash, hash]);

  return [expanded, setExpanded];
};
